"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Pencil_exports = {};
__export(Pencil_exports, {
  default: () => Pencil_default
});
module.exports = __toCommonJS(Pencil_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.8906 4.17578C15.5651 3.91536 15.1875 3.79818 14.7578 3.82422C14.3411 3.85026 13.9896 4.00651 13.7031 4.29297L12.7461 5.25L15.0898 7.57422L16.0273 6.63672C16.3789 6.28516 16.5417 5.86849 16.5156 5.38672C16.4896 4.89193 16.2812 4.48828 15.8906 4.17578L16.5156 3.39453C17.1406 3.88932 17.4727 4.53385 17.5117 5.32812C17.5508 6.10938 17.2904 6.77995 16.7305 7.33984L8.21484 15.875C8.00651 16.0833 7.77214 16.2591 7.51172 16.4023C7.26432 16.5456 7.00391 16.6562 6.73047 16.7344L4.25 17.3984C3.96354 17.4896 3.70312 17.431 3.46875 17.2227C3.2474 17.0143 3.16276 16.7604 3.21484 16.4609L3.66406 13.8047C3.71615 13.4661 3.82031 13.1406 3.97656 12.8281C4.13281 12.5156 4.33464 12.2357 4.58203 11.9883L12.9805 3.58984C13.4622 3.12109 14.0417 2.86719 14.7188 2.82812C15.3958 2.78906 15.9948 2.97786 16.5156 3.39453L15.8906 4.17578ZM14.5039 8.17969L12.1602 5.83594L5.30469 12.7109C5.1224 12.8802 4.97266 13.0755 4.85547 13.2969C4.7513 13.5052 4.67969 13.7266 4.64062 13.9609L4.25 16.3828L6.45703 15.7773C6.66536 15.7122 6.85417 15.6341 7.02344 15.543C7.19271 15.4388 7.35547 15.3151 7.51172 15.1719L14.5039 8.17969ZM8.74219 17.3398C8.74219 17.1966 8.78776 17.0794 8.87891 16.9883C8.98307 16.8841 9.10677 16.832 9.25 16.832H17.5898C17.7201 16.832 17.8307 16.8841 17.9219 16.9883C18.026 17.0794 18.0781 17.1966 18.0781 17.3398C18.0781 17.4701 18.026 17.5872 17.9219 17.6914C17.8307 17.7826 17.7201 17.8281 17.5898 17.8281H9.25C9.10677 17.8281 8.98307 17.7826 8.87891 17.6914C8.78776 17.5872 8.74219 17.4701 8.74219 17.3398Z",
      fill: "currentColor"
    }
  )
);
const SvgPencil = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Pencil_default = SvgPencil;
